module.exports = __webpack_public_path__ + "img/11.d67bdef3.jpg";